import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type TransactionFragment = { id: string, pk: number, date: any, amount: number, feeAmt: number, transactionId: string | null, type: Types.TransactionTypeEnum };

export const TransactionFragmentDoc = gql`
    fragment TransactionFragment on TransactionType {
  id
  pk
  date
  type: transactionType
  amount
  feeAmt
  transactionId
}
    `;